module.exports = __webpack_public_path__ + "img/oseibo_h02.4b63a287.png";